import { useState, useEffect, createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import { getApiService } from "../services/ApiService";
import Cookies from 'js-cookie';
import { getCookieOptions } from '../utils/cookieUtils';

export const LanguageContext = createContext();

export const LanguageProvider = ({children}) => {

    const isLoggedIn = !!Cookies.get('authData');
    const [pageContent, setPageContent] = useState([]);
    let location = useLocation();
    
    const [language, setLanguage] = useState('eng');
    
    useEffect(() => {
        if(isLoggedIn){
            getContent();
        }
    }, [isLoggedIn, location.pathname, language]);

    function getContent(){

            // Retrieve site_cd from localStorage
            const appData = localStorage.getItem('appData');
            const decodedData = appData ? JSON.parse(atob(appData)) : null;
            let siteCd = '';
            if (decodedData && typeof decodedData === 'object' && !Array.isArray(decodedData)) {
                const values = Object.values(decodedData);
                if (values.length && typeof values[0] === 'object' && values[0] !== null && 'site_cd' in values[0]) {
                    siteCd = values[0].site_cd;
                } else if ('site_cd' in decodedData) {
                    siteCd = decodedData.site_cd;
                }
            }

            const pathName = location.pathname;
            const page = pathName.startsWith('/') ? pathName.slice(1) : pathName;
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
            const headers = {
                        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
                        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
                        };
            const targetUrl = process.env.REACT_APP_API_CMS_CONTENT_ENDPOINT;            
            getApiService(
                baseUrl,
                targetUrl,
                {
                    page: page ? page : 'overview',
                    site_cd: siteCd ? siteCd : 'CGMBR',
                    lang: Cookies.get('lang') || 'eng'
                },
                headers
            )
            .then((response) => {
                if(response?.data && response.data.status === 'SUCCESS'){
                    const result = response.data.data;
                    console.log('overview...', result);
                    setPageContent(result);
                }
            })
            .catch((error) =>{
                console.log(error);
            })
    }

    const toggleLanguage  = (lang) => {
        Cookies.set('lang', lang, getCookieOptions());
        Cookies.set('portal_lang', lang, getCookieOptions());
        setLanguage(lang);
        getContent();
    };
    

    return(
        <LanguageContext.Provider value={{pageContent, toggleLanguage}}>
        {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);